import { assert, release } from './Debug';
import { isNullOrUndefined, isObject } from '../utilities';
export function boxValue(value) {
    if (isNullOrUndefined(value) || isObject(value)) {
        return value;
    }
    return Object(value);
}
export function toKeyValueArray(object) {
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var array = [];
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            array.push([k, object[k]]);
        }
    }
    return array;
}
export function isPrototypeWriteable(object) {
    return Object.getOwnPropertyDescriptor(object, 'prototype').writable;
}
export function hasOwnProperty(object, name) {
    return Object.prototype.hasOwnProperty.call(object, name);
}
export function propertyIsEnumerable(object, name) {
    return Object.prototype.propertyIsEnumerable.call(object, name);
}
/**
 * Returns a property descriptor for the own or inherited property with the given name, or
 * null if one doesn't exist.
 */
export function getPropertyDescriptor(object, name) {
    do {
        var propDesc = Object.getOwnPropertyDescriptor(object, name);
        if (propDesc) {
            return propDesc;
        }
        object = Object.getPrototypeOf(object);
    } while (object);
    return null;
}
export function hasOwnGetter(object, name) {
    var d = Object.getOwnPropertyDescriptor(object, name);
    return !!(d && d.get);
}
export function getOwnGetter(object, name) {
    var d = Object.getOwnPropertyDescriptor(object, name);
    return d ? d.get : null;
}
export function hasOwnSetter(object, name) {
    var d = Object.getOwnPropertyDescriptor(object, name);
    return !!(d && !!d.set);
}
export function defineReadOnlyProperty(object, name, value) {
    Object.defineProperty(object, name, {
        value: value,
        writable: false,
        configurable: true,
        enumerable: false
    });
}
export function copyOwnPropertyDescriptors(object, template, filter, overwrite, makeWritable) {
    if (filter === void 0) { filter = null; }
    if (overwrite === void 0) { overwrite = true; }
    if (makeWritable === void 0) { makeWritable = false; }
    var names = Object.getOwnPropertyNames(template);
    for (var _i = 0, names_1 = names; _i < names_1.length; _i++) {
        var property = names_1[_i];
        if (property != 'constructor' && hasOwnProperty(template, property) && (!filter || filter(property))) {
            var descriptor = Object.getOwnPropertyDescriptor(template, property);
            if (!overwrite && hasOwnProperty(object, property)) {
                continue;
            }
            release || assert(descriptor);
            try {
                if (makeWritable && descriptor.writable === false) {
                    descriptor.writable = true;
                }
                Object.defineProperty(object, property, descriptor);
            }
            catch (e) {
                assert('Can\'t define: ' + property);
            }
        }
    }
}
export function copyPropertiesByList(object, template, propertyList) {
    for (var i = 0; i < propertyList.length; i++) {
        var property = propertyList[i];
        object[property] = template[property];
    }
}
export function defineNonEnumerableGetter(obj, name, getter) {
    Object.defineProperty(obj, name, { get: getter,
        configurable: true,
        enumerable: false
    });
}
export function defineNonEnumerableProperty(obj, name, value) {
    Object.defineProperty(obj, name, { value: value,
        writable: true,
        configurable: true,
        enumerable: false
    });
}
